import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LedgerService {
  constructor(private router: Router, private http: HttpClient) { }

  private headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: '*/*'
  });

  GetAllParties(): Observable<any> {
    const body = new HttpParams({});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllParties`, body, options);
  }

  SearchParties(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/SearchParties`, body, options);
  }

  GetLedgerByID(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetLedgerByID`, body, options);
  }

  GetAddressbyId(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAddressbyId`, body, options);
  }

  GetAllLedgerGroup(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllLedgerGroup`, body, options);
  }

  GetAllTaxCategory(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllTaxCategory`, body, options);
  }

  GetAllState(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllState`, body, options);
  }

  GetAllLedger(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllLedger`, body, options);
  }

  GetLedgers(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetLedgers`, body, options);
  }

  InsertLedger(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/InsertLedger`, body, options);
  }

  DeleteLedger(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/DeleteLedger`, body, options);
  }

  UpdateLedger(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/UpdateLedger`, body, options);
  }

  GetAllPayment(): Observable<any> {
    const body = new HttpParams({});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetAllPayment`, body, options);
  }

  GetLedgerfromGroup(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/GetLedgerfromGroup`, body, options);
  }

  GetCurrentBalance(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/CurrBalance`, body, options);
  }

  MarkWhatsAppBillSent(ledgerId: number | string): Observable<any> {
    const body = new HttpParams()
      .set('LedgerID', String(ledgerId));
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/MarkWhatsAppBillSent`, body, options);
  }

  UpdateLedgerMobileNumber(ledgerId: number | string, mobileNumber: string): Observable<any> {
    const body = new HttpParams()
      .set('LedgerID', String(ledgerId))
      .set('MobileNumber', mobileNumber);
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Ledger/UpdateLedgerMobileNumber`, body, options);
  }

  normalizeLedgerMobile(mobileNumber: string): string {
    const digits = String(mobileNumber ?? '').replace(/\D/g, '');
    if (!digits) {
      return '';
    }

    if (digits.length === 10) {
      return digits;
    }

    if (digits.length === 11 && digits.startsWith('0')) {
      return digits.slice(1);
    }

    if (digits.length === 12 && digits.startsWith('91')) {
      return digits.slice(2);
    }

    return digits.length > 10 ? digits.slice(-10) : digits;
  }

  isDuplicateMobile(
    mobileNumber: string,
    ledgers: { ledgerId?: number | string; mobileNumber?: string }[],
    excludeLedgerId?: number | string,
  ): boolean {
    const normalized = this.normalizeLedgerMobile(mobileNumber);
    if (!normalized) {
      return false;
    }

    return (ledgers ?? []).some((ledger) => {
      if (excludeLedgerId != null && String(ledger.ledgerId) === String(excludeLedgerId)) {
        return false;
      }

      const existing = this.normalizeLedgerMobile(ledger.mobileNumber ?? '');
      return !!existing && existing === normalized;
    });
  }

  findLedgerByMobile(
    mobileNumber: string,
    ledgers: { ledgerId?: number | string; ledgerName?: string; label?: string; mobileNumber?: string }[],
    excludeLedgerId?: number | string,
  ): { ledgerId?: number | string; ledgerName?: string; label?: string } | null {
    const normalized = this.normalizeLedgerMobile(mobileNumber);
    if (!normalized) {
      return null;
    }

    const match = (ledgers ?? []).find((ledger) => {
      if (excludeLedgerId != null && String(ledger.ledgerId) === String(excludeLedgerId)) {
        return false;
      }

      const existing = this.normalizeLedgerMobile(ledger.mobileNumber ?? '');
      return !!existing && existing === normalized;
    });

    return match ?? null;
  }
}
